<template>
  <div class="profile-cnt">
    <header class="inner-head">
      <div class="left-col">
        <span class="icon-Btn" @click="goBack()">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16">
            <path
              d="M7.993 14.119c.395.432.4 1.127.007 1.558-.39.429-1.019.434-1.418-.004L.297 8.779c-.393-.43-.4-1.122 0-1.56L6.582.326C6.975-.105 7.607-.11 8 .32c.39.428.392 1.121-.007 1.559L3.414 6.902h13.584C17.55 6.902 18 7.39 18 8c0 .606-.452 1.097-1.002 1.097H3.414l4.58 5.023z"
            />
          </svg>
        </span>

        <h2>{{$t('profile')}}</h2>
      </div>

      <div class="rgt-col" v-if="walletBalance">
        <div class="wallet-box">
          <span class="wallet-icon">
            <img :src="require('../assets/images/wallet-icon.svg')" />
          </span>
          <div class="wallet-text">
            <span class="text-value">{{walletBalance}}</span>
            <span class="text-title">{{$t('inWallet')}}</span>
          </div>
        </div>
      </div>
    </header>

    <section class="mid-cnt">
      <div class="field-row profile-img">
        <!-- <AddProfilePic
          v-model="userInfo.profileImageUrl"
          :imageUrl="userInfo.profileImageUrl"
          @uploadImageList="previewPhoto"
        />-->
        <span class="profile-icon">
         <img :src="userInfo.profileImageUrl" v-if="userInfo.profileImageUrl" />
        <img src="../assets/images/dummy.png" v-else />
        </span>
      </div>

      <div class="fomr-box">
        <div class="field-row">
          <label class="text-label">{{$t('fullName')}}</label>
          <input
            name
            value="Ritu Raj Srivastava"
            class="input-style"
            :placeholder="$t('fullName')"
            v-model="userInfo.firstName + ' ' + userInfo.lastName"
            readonly
          />
        </div>

        <div class="field-row">
          <label class="text-label">{{$t('mobileNumber')}}</label>
          <input
            inputmode="tel"
            value="8826484966"
            class="input-style"
            :placeholder="$t('mobileNumber')"
            v-model="userInfo.phone"
            readonly
          />
        </div>

        <div class="field-row">
          <label class="text-label">{{$t('gender')}}</label>

          <div class="optionbox">
            <div class="input_radicol">
              <label class="input-check">
                <!-- <input type="radio" value="male" v-model="genderName" readonly/> -->
                <span class="text-label" @click="getUserGender('male')">{{$t('male')}}</span>
                <span class="checkmark" :class="{'active' : genderName ==='male'}"></span>
              </label>
            </div>

            <div class="input_radicol">
              <label class="input-check">
                <!-- <input type="radio" value="female" v-model="genderName" readonly /> -->
                <span class="text-label">{{$t('female')}}</span>
                <span class="checkmark" :class="{'active' : genderName ==='female'}"></span>
              </label>
            </div>
          </div>
        </div>

        <div class="field-row" v-if="getUserDetail && getUserDetail.freelancer_details">
          <label class="text-label">{{$t('tellAboutYouself')}}</label>
          <textarea
            class="textare-style"
            :placeholder="$t('writeHere')"
            v-model="getUserDetail.freelancer_details.job_description"
          ></textarea>
        </div>

        <div class="field-row">
          <label class="text-label">{{$t('address')}}</label>

          <textarea
            class="textare-style"
            :placeholder="$t('writeHere')"
            v-if="userInfo.city"
            v-model="userInfo.city.name"
            readonly
          ></textarea>
        </div>

        <div class="field-row">
          <label class="text-label">{{$t('skills')}}</label>
          <ul class="textare-style skills">
            <li v-for="(skill,index) in allSkills" :key="index">
              <span class="label-heading">{{skill.category}}</span>
              <ul class="chiplisting">
                <li v-for="(key,index) in skill.SkillsCategoryType" :key="index" :class="{'active' : (checkIndex(skill.category,key) == 'active')}">
                  <span
                    class="text-label"
                    @click="selectValue(skill.category,key)" 
                  >{{key}}</span>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <footer class="footer-bottom">
      <button class="button" @click="postUserDetailObject()">{{$t('updateYourProfile')}}</button>
    </footer>
    <CustomToaster :dataValue="toasterData" v-if="isValidDetail" />
    <div class="loader" v-if="loading">
      <img src="../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>
<script>
import ApiCaller from "../utils/apicaller";
import constant from "../utils/constant";
import AddProfilePic from "../components/AddProfilePic";
import CustomToaster from "../components/Common/CustomToaster";
import { mapGetters } from "vuex";
import types from "../store/types";
import "../assets/css/profile.css";
import { SessionHelper, X_AUTH_ID } from "../utils/session";
export default {
  name: "Profile",
  computed: {
    ...mapGetters(["userInfo"])
  },
  components: {
    AddProfilePic,
    CustomToaster
  },
  data() {
    return {
      toasterData: {},
      getUserDetail: {},
      isValidDetail: false,
      addFeedBackPhoto: null,
      loading: false,
      genderName: "",
      value: null,
      allSkills: [],
      selected: [],
      walletBalance: ''
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getUserDetailObject() {
      this.loading = true
      ApiCaller(constant.BASE_API_URL, "user/userdetails/", "get")
        .then(data => {
          this.loading = false
          this.getUserDetail = data.data;
          if(data.data && data.data.freelancer_details && data.data.freelancer_details.skills){
            this.selected=data.data.freelancer_details.skills
          }
          if(this.isValidDetail){
            this.toasterData = {
              msg: this.$t("editedProfileSuccefully"),
              color: "#138808",
              iconName: "check"
            };
          }
        })
        .catch(err => {
          this.loading = false
          console.log(err);
        });
    },
    postUserDetailObject() {
      this.loading = true
      if (this.getUserDetail && this.getUserDetail.freelancer_details) {
        var obj = {
          data :  { skills: this.selected ,          
          job_description: this.getUserDetail.freelancer_details.job_description},
          update_of: 'Freelancer'
        };
      }
      ApiCaller(constant.BASE_API_URL, "user/userdetails/", "patch", obj)
        .then(data => {
          this.loading = false
          this.getUserDetail = data.data;
          this.getUserDetailObject()
          this.isValidDetail = true
        })
        .catch(err => {
          console.log(err);
        });
    },
    getUserSkills() {
      ApiCaller(constant.BASE_API_URL, "user/skills/", "get")
        .then(data => {
          this.allSkills = data.data;
        })
        .catch(err => {
          console.log(err);
          //  this.toasterData = {
          //     msg: this.$t('userNotAuthorized'),
          //     color: "#ff4643",
          //     iconName: "error"
          //   };
          //   this.isValidDetail = true;
        });
    },
    selectValue(category, SkillsCategoryType) {
      if (this.selected.length > 0) {
        let index = this.selected
          .map(it => {
            return it.category;
          })
          .indexOf(category);
        if (index > -1) {
          let index2 = this.selected[index].SkillsCategoryType
            .map(it => {
              return it;
            })
            .indexOf(SkillsCategoryType);

          if (index2 > -1) {
            let data = this.selected[index].SkillsCategoryType.filter(
              it => it != SkillsCategoryType
            );

            if (data.length > 0) {
              this.selected[index].SkillsCategoryType = data;
            } else {
              let dataValue = this.selected.filter(
                it => it.category != category
              );
              this.selected = dataValue;
            }
          } else {
            this.selected[index].SkillsCategoryType.push(SkillsCategoryType);
          }
        } else {
          this.selected.push({
            category: category,
            SkillsCategoryType: [SkillsCategoryType]
          });
        }
      } else {
        this.selected.push({
          category: category,
          SkillsCategoryType: [SkillsCategoryType]
        });
      }
    },
    checkIndex(category,SkillsCategoryType ) {
      if (this.selected.length > 0) {
        let index = this.selected
          .map(it => {
            return it.category;
          })
          .indexOf(category);
        if (index > -1) {
          let index2 = this.selected[index].SkillsCategoryType
            .map(it => {
              return it;
            })
            .indexOf(SkillsCategoryType);
          if (index2 > -1) {
            return "active";
          } else {
            return "inactive";
          }
        } else {
          return "inactive";
        }
      } else {
        return "inactive";
      }
    },
  getUserAmount() {
      ApiCaller(constant.USERINFO_URL, SessionHelper.getCookie(X_AUTH_ID),
        "get")
        .then(data => {
          this.walletBalance = data.data.walletBalance
        })
        .catch(err => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getUserAmount()
    this.getUserSkills();
    this.getUserDetailObject();
    this.genderName = this.userInfo.gender;
  }
};
</script>